import React from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { IconChevronLeft } from "../../../assets/icons";

function SkeletonOrderItemShow() {
  return (
    <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
      <Col xs={12} lg={4} className="pt-1 mt-3 tab-border-bottom fs-085">
        <Row className="px-1 px-md-2">
          <Card
            className="w-100 rounded-3 border-top-0 border-bottom-0 border-end-0 shadow-sm px-0"
            style={{ borderRight: "5px solid #09a463" }}
          >
            <Card.Body className="px-3">
              <Row>
                <Col xs>
                  <div>
                    <span className="pe-1 fs-07 text-secondary">کد سفارش:</span>
                    <Skeleton width={50} height={15} />
                  </div>
                  <div className="pt-2">
                    <span className="pe-1 fs-07 text-secondary">مبلغ:</span>
                    <span className="fw-bold">
                      <Skeleton width={50} height={15} />
                    </span>
                  </div>
                </Col>
                <Col xs="auto" className="text-end fs-08">
                  <div className="">
                    <Skeleton width={50} height={15} />
                  </div>

                  <div className="pt-2">
                    <span className="pe-1 fs-07 text-secondary ">تعداد :</span>
                    <span className="fw-bold pe-1">
                      <Skeleton width={50} height={15} />
                    </span>
                  </div>
                </Col>
              </Row>

              <Row className="pt-2 border-top mt-2 ">
                <Col xs="auto" className="my-auto">
                  <Button
                    variant="primary"
                    className="fs-075 mt-1 bg-white rounded-2 bg-light-3 py-1 px-2 small-svg"
                  >
                    مشاهده
                    <IconChevronLeft fillColor="white" />
                  </Button>
                </Col>
                <Col className="text-end ps-0">
                  <div className="d-flex aling-items-center justify-content-end order-image">
                    <Skeleton
                      width={35}
                      height={35}
                      className="rounded-circle"
                    />
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Row>
      </Col>

      {/* <Col xs={12} lg={4} className=" mt-2">
        <Card className="w-100 rounded-4">
          <Card.Body className="px-3">
            <Row className=" mt-2">
              <Col xs="6">
                <Skeleton width="100%" height={17} />
              </Col>
              <Col xs="6">
                <Skeleton width="100%" height={17} />
              </Col>
            </Row>
            <Row className=" mt-1">
              <Col xs="6">
                <Skeleton width="80%" height={15} />
              </Col>
            </Row>
            <Row className=" mt-1">
              <Col xs="6">
                <Skeleton width="100%" height={15} />
              </Col>
            </Row>
            <div className="pr-2 arrow-left">
              <div className="bg-light-gray text-center rounded-4 border ps-2 pe-1 fs-085 small-svg-1">
                مشاهده
                <IconChevronLeft fillColor="dark" />
              </div>
            </div>
            <div className="pt-3 mt-2 border-dashed-top">
              <Row className="mb-2 px-3">
                <Col xs="auto" className=" p-0 m-0 pe-2">
                  <Skeleton width={50} height={38} />
                </Col>
                <Col xs="auto" className=" p-0 m-0 pe-2">
                  <Skeleton width={50} height={38} />
                </Col>
                <Col xs="auto" className=" p-0 m-0 pe-2 ">
                  <Skeleton width={50} height={38} />
                </Col>
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Col> */}
    </SkeletonTheme>
  );
}

export default SkeletonOrderItemShow;
